const quicklinkMenu = document.getElementById('quicklinksCollapse');
if (quicklinkMenu.length > 0) {
  quicklinkMenu.addEventListener('show.bs.collapse', (e) => {
    // eslint-disable-next-line no-use-before-define
    collpaseAllMenuItems($(e.target).attr('id'));
  });
  quicklinkMenu.addEventListener('shown.bs.collapse', (e) => {
    // eslint-disable-next-line no-use-before-define
    collpaseAllMenuItems($(e.target).attr('id'));
  });
  quicklinkMenu.addEventListener('hide.bs.collapse', (e) => {
    // eslint-disable-next-line no-use-before-define
    collpaseAllMenuItems($(e.target).attr('id'));
  });
}

function collpaseAllMenuItems(e) {
  $(quicklinkMenu).find(`.collapse:not(${e})`).collapse('hide');
}

const quicklinkMenuButtons = $('#quicklinksCollapse button[data-bs-toggle="collapse"]');
if (quicklinkMenuButtons.length > 0) {
  quicklinkMenuButtons.each(function () {
    const thisCollapse = $(this).siblings('.collapse');
    const thisLi = $(this).parent('li');
    let hoverTimeout;

    $(this).on('click', () => {
      if (thisCollapse.hasClass('clicked') === true) {
        thisCollapse.removeClass('clicked').collapse('hide');
      } else {
        thisCollapse.addClass('clicked').collapse('show');
      }
    });

    thisLi.hover((e) => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
      hoverTimeout = setTimeout(() => {
        if (
          thisCollapse.hasClass('clicked') === true
          || thisCollapse.hasClass('show') === true
        ) {
          $(quicklinkMenu).find(`.collapse:not(#${thisCollapse.attr('id')})`).collapse('hide');
          return;
        }
        e.stopPropagation();
        collpaseAllMenuItems($(e.target).attr('data-bs-target'));
        thisCollapse.collapse('show');
      }, 100);
    }, (e) => {
      // check if rendered content is in LI element
      // check if clicked to open
      if (
        thisCollapse.hasClass('clicked') === true
        || thisCollapse.hasClass('link-only') === false
      ) {
        return;
      }

      e.stopPropagation();
      thisCollapse.collapse('hide');
    });
  });
}
const quicklinkMenuCloseContent = $('#quicklinksCollapse .rendered-content > span');
if (quicklinkMenuCloseContent.length > 0) {
  quicklinkMenuCloseContent.each(function () {
    const thisCollapse = $(this).parents('.collapse').first();
    $(this).on('click', (e) => {
      if (e.target.classList.contains('icon-close')) {
        thisCollapse.removeClass('clicked').collapse('hide');
      } else if (thisCollapse.hasClass('clicked') === true) {
        thisCollapse.removeClass('clicked').collapse('hide');
      } else {
        thisCollapse.addClass('clicked').collapse('show');
      }
    });
  });
}

$(document).keyup((e) => {
  if (e.key === 'Escape') { // escape key maps to keycode `27`
    if ($(quicklinkMenu).find('.collapse.show').length > 0) {
      $(quicklinkMenu).find('.collapse.show').collapse('hide').removeClass('clicked');
    } else if ($(quicklinkMenu).hasClass('show')) {
      $(quicklinkMenu).collapse('hide');
    }
  }
});

if ($('#quicklinksMobile').length > 0) {
  $('#quicklinksMobile > .close-button .btn-close').on('click', (e) => {
    e.preventDefault();
    $('body').toggleClass('quicklinks-mobile-hide');
  });
}
